import React, { useCallback } from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation } from "react-apollo";
import { GET_CLIENT } from "./queries";

import map from "lodash/map";
import compact from "lodash/compact";
import unset from "lodash/unset";
import head from "lodash/head";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import concat from "lodash/concat";
import slice from "lodash/slice";
import debounce from "lodash/debounce";

import withSession from "./withSession";
import {
  ADD_CHALLENGE_TO_CLIENT,
  UPDATE_CHALLENGE,
  DELETE_CHALLENGE,
  IMAGE_UPLOAD,
  PUBLISH_CHALLENGE,
} from "./mutations";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import { modules } from "constants/reactQuill";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./Forms/SignUpWizard/datePicker.css";
import { removeFields } from "../functions/";

const MAXSIZE = 100000000; //bytes
const FILETYPES = {
  "application/pdf": [".pdf"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/gif": [".gif"],
  // Add more types if needed
};

const typeOptions = [
  {
    value: "once",
    label: "Once",
  },
  {
    value: "weekly",
    label: "Weekly",
  },
];

// Pass FILETYPES directly to Dropzone
<Dropzone accept={FILETYPES} />;

function ChallengeManager(props) {
  const [modal, setModal] = React.useState(false);
  const [publishModal, setPublishModal] = React.useState(false);
  const [unpublishModal, setUnpublishModal] = React.useState(false);
  const [copyModal, setCopyModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [modalPassword, setModalPassword] = React.useState(false);

  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [difficulty, setDifficulty] = React.useState("");
  const [duration, setDuration] = React.useState(0);
  const [timedChallenge, setTimedChallenge] = React.useState(false);
  const [startDate, setStartDate] = React.useState("");
  const [challengeType, setChallengeType] = React.useState(head(typeOptions));
  const [communityId, setCommunityId] = React.useState(null);
  const [commitment, setCommitment] = React.useState("");
  const [imageLink, setImageLink] = React.useState("");
  const [scheduleItems, setScheduleItems] = React.useState([]);
  const [welcomeItem, setWelcomeItem] = React.useState({});
  const [endingItem, setEndingItem] = React.useState({});
  const [showError, setShowError] = React.useState("");
  const [showErrorConfirm, setShowErrorConfirm] = React.useState("");

  const [activeItem, setActiveItem] = React.useState({
    value: "welcome",
    label: "Welcome",
  });

  const [editChallengeId, setEditChallengeId] = React.useState("");
  const [publishChallengeId, setPublishChallengeId] = React.useState("");
  const [copyChallenge, setCopyChallenge] = React.useState(null);
  const [deleteChallengeId, setDeleteChallengeId] = React.useState("");
  // const [multipleActivities, setMultipleActivities] = React.useState("");

  const [addChallengeToClient] = useMutation(ADD_CHALLENGE_TO_CLIENT);
  const [updateChallenge] = useMutation(UPDATE_CHALLENGE);
  const [publishChallenge] = useMutation(PUBLISH_CHALLENGE);
  const [deleteChallenge] = useMutation(DELETE_CHALLENGE);
  const [uploadImage] = useMutation(IMAGE_UPLOAD);

  const validateFile = (file) => {
    if (file.size > MAXSIZE) {
      // this.setState({ error: 'file is too big' })
      return false;
    }

    // if (!includes(FILETYPES, file.type)) {
    //   this.setState({
    //     error: 'File Type not accepted',
    //     progress: null,
    //   })
    //   return false
    // }
    return true;
  };
  const getBase64ImageFromFile = async (file) => {
    if (!file) return null;
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          resolve(reader.result);
        },
        false
      );

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(file);
    });
  };
  const handleOnDrop = async (files, rejectedFiles) => {
    // this.setState({ error: null, progress: files.length })
    let urls = await Promise.all(
      map(files, async (file) => {
        if (validateFile(file)) {
          const url = await getBase64ImageFromFile(file);
          return url;
        }
      })
    );
    // setImageLink(head(urls))
    uploadImage({
      variables: {
        fileUrl: head(urls),
        collection: `${props?.session?.me?.clientName}/challenges`,
      },
    }).then((data) => {
      setImageLink(data?.data?.uploadImage);
    });
  };

  const handleOnDropSchedule =
    (index, admin = false) =>
    async (files, rejectedFiles) => {
      // this.setState({ error: null, progress: files.length })
      let urls = await Promise.all(
        map(files, async (file) => {
          if (validateFile(file)) {
            const url = await getBase64ImageFromFile(file);
            return url;
          }
        })
      );
      // setImageLink(head(urls))
      uploadImage({
        variables: {
          fileUrl: head(urls),
          collection: `${props?.session?.me?.clientName}/CommunityImage`,
        },
      }).then((data) => {
        onChangeScheduleItem(
          data?.data?.uploadImage,
          admin ? "adminCommunityPostImage" : "communityPostImage",
          index,
          welcomeItem
        );
      });
    };

  const debouncedOnChange = useCallback(
    debounce((value, field, key, welcomeItem) => {
      onChangeScheduleItem(value, field, key, welcomeItem);
    }, 300),
    [] // Empty dependency array so it's only created once
  );

  const handleClose = () => {
    setModal(false);
    setTitle("");
    setDescription("");
    setDuration(0);
    setTimedChallenge(false);
    setStartDate("");
    setChallengeType(head(typeOptions));
    setCommunityId(null);
    setDifficulty("");
    setCommitment("");
    setImageLink("");
    setWelcomeItem({});
    setEndingItem({});
    setScheduleItems([]);
    setActiveItem({ value: "welcome", label: "Welcome" });
    setEditChallengeId("");
  };

  const handleOpenPublish = (challenge) => {
    setPublishModal(true);
    setPublishChallengeId(challenge?._id);
  };

  const handleClosePublish = (user) => {
    setPublishModal(false);
    setPublishChallengeId("");
  };

  const handleOpenUnpublish = (challenge) => {
    setUnpublishModal(true);
    setPublishChallengeId(challenge?._id);
  };

  const handleCloseUnpublish = (user) => {
    setUnpublishModal(false);
    setPublishChallengeId("");
  };

  const handleOpenCopy = (challenge) => {
    setCopyModal(true);
    setCopyChallenge(challenge);
  };

  const handleCloseCopy = (user) => {
    setCopyModal(false);
    setCopyChallenge(null);
  };

  const handleOpenDelete = (challenge) => {
    setDeleteModal(true);
    setDeleteChallengeId(challenge?._id);
  };

  const handleCloseDelete = (user) => {
    setDeleteModal(false);
    setDeleteChallengeId("");
  };

  const handleChangeDuration = (value) => {
    setDuration(value);
    let newScheduleItems = cloneDeep(scheduleItems);
    // Changing slice to only occur when saving
    // if (newScheduleItems.length > value)
    //   newScheduleItems = slice(newScheduleItems, 0, value);
    while (newScheduleItems.length < value) {
      newScheduleItems.push({});
    }
    setScheduleItems(newScheduleItems);
  };

  const onChangeScheduleItem = (value, name, index, welcomeItem = null) => {
    console.log(index, name, value);
    if (index === "welcome") {
      let newItem = cloneDeep(welcomeItem);
      set(newItem, `${name}`, value);
      setWelcomeItem(newItem);
    } else if (index === "ending") {
      let newItem = cloneDeep(endingItem);
      set(newItem, `${name}`, value);
      setEndingItem(newItem);
    } else {
      let newScheduleItems = cloneDeep(scheduleItems);
      set(newScheduleItems, `${index}.${name}`, value);
      console.log(newScheduleItems);
      setScheduleItems(newScheduleItems);
    }
  };

  const computeWelcome = (welcomeItem) => {
    // Compute welcomeItem with tasks.
    const computedWelcome = {
      ...welcomeItem,
      tasks: [
        ...(welcomeItem.videoLink
          ? [{ label: "Watch the welcome video" }]
          : []),
        ...(welcomeItem.activities || []).map((activity) => {
          const matchingOption = options.find(
            (option) =>
              option.value === activity || option.value === activity.value
          );
          return { label: matchingOption.label };
        }),
      ],
    };
    return computedWelcome;
  };

  const computeEnding = (endingItem) => {
    // Compute endingItem (modify similarly if needed)
    const computedEnding = { ...endingItem };
    return computedEnding;
  };

  const computeSchedule = (scheduleItems, duration) => {
    // Compute the schedule array with tasks, startDay, endDay, etc.
    const computedSchedule = slice(scheduleItems, 0, duration).map(
      (item, index) => {
        const computedItem = {
          ...item,
          startDay: index + 1,
          endDay: index + 1,
          tasks: [
            ...(item.videoLink ? [{ label: "Watch today's video" }] : []),
            ...(item.activities || []).map((activity) => {
              const matchingOption = options.find(
                (option) =>
                  option.value === activity || option.value === activity.value
              );
              return { label: matchingOption.label };
            }),
          ],
          // Process habits similarly if needed:
          habits: (item.habits || []).map((habit) => ({ ...habit })),
        };
        return computedItem;
      }
    );
    return computedSchedule;
  };

  const createChallenge = () => {
    const computedWelcome = computeWelcome(welcomeItem);

    const computedEnding = computeEnding(endingItem);

    const computedSchedule = computeSchedule(scheduleItems, duration);

    // Ensure startDate is properly formatted as an ISO string if it's a Date object.
    const formattedStartDate =
      timedChallenge && startDate
        ? typeof startDate === "object" && startDate.toISOString
          ? startDate.toISOString()
          : startDate
        : null;

    // Build the complete challenge object.
    const challenge = {
      published: false,
      title,
      description,
      difficulty,
      duration,
      commitment,
      imageLink,
      startDate: formattedStartDate,
      type: timedChallenge ? challengeType?.value || "once" : "once",
      // communityId: timedChallenge ? communityId : null,  // Uncomment if needed
      welcomeItem: computedWelcome,
      endingItem: computedEnding,
      schedule: computedSchedule,
    };

    // Remove __typename and _id recursively from the complete object.
    const cleanedChallenge = removeFields(challenge, ["__typename", "_id"]);

    console.log(cleanedChallenge);

    return cleanedChallenge;
  };

  const handleAddChallenge = () => {
    addChallengeToClient({
      variables: {
        name: props?.session?.me?.clientName,
        challenge: createChallenge(),
      },
      refetchQueries: [
        {
          query: GET_CLIENT,
          variables: {
            name: props?.session?.me?.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleCopyChallenge = () => {
    let newChallenge = cloneDeep(copyChallenge);

    const { welcomeItem, endingItem, schedule, duration } = newChallenge;

    const computedWelcome = computeWelcome(welcomeItem);

    const computedEnding = computeEnding(endingItem);

    const computedSchedule = computeSchedule(schedule, duration);

    newChallenge.welcomeItem = computedWelcome;
    newChallenge.endingItem = computedEnding;
    newChallenge.schedule = computedSchedule;
    newChallenge.published = false;

    // Remove __typename and _id recursively from the complete object.
    const cleanedChallenge = removeFields(newChallenge, [
      "__typename",
      "_id",
      "activeSchedule",
      "currentDay",
    ]);

    addChallengeToClient({
      variables: {
        name: props?.session?.me?.clientName,
        challenge: cleanedChallenge,
      },
      refetchQueries: [
        {
          query: GET_CLIENT,
          variables: {
            name: props?.session?.me?.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleCloseCopy();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleOpenEdit = (challenge) => {
    setModal(true);
    setTitle(challenge?.title);
    setDescription(challenge?.description);
    setDuration(challenge?.duration);
    setTimedChallenge(Boolean(challenge?.startDate));
    setStartDate(challenge?.startDate);
    console.log(typeOptions.find((option) => option.value === challenge?.type));
    setChallengeType(
      typeOptions.find((option) => option.value === challenge?.type) ||
        head(typeOptions)
    );
    setCommunityId(challenge?.communityId);
    setDifficulty(challenge?.difficulty);
    setCommitment(challenge?.commitment);
    setImageLink(challenge?.imageLink);
    setWelcomeItem(cloneDeep(challenge?.welcomeItem));
    setEndingItem(cloneDeep(challenge?.endingItem));
    setScheduleItems(cloneDeep(challenge?.schedule));
    setEditChallengeId(challenge?._id);
    setShowError("");
  };

  const handleEditChallenge = async (editChallengeId) => {
    const challengeUpdate = {
      ...createChallenge(),
      communityId: timedChallenge ? communityId : null,
    };

    // Use cleanedChallengeUpdate for your mutation
    try {
      await updateChallenge({
        variables: {
          challengeId: editChallengeId,
          name: props?.session?.me?.clientName,
          challengeUpdate: challengeUpdate,
        },
        refetchQueries: [
          {
            query: GET_CLIENT,
            variables: {
              name: props?.session?.me?.clientName,
            },
          },
        ],
      })
        .then(() => {
          handleClose();
        })
        .catch((error) => {
          setShowError(error.message);
        });
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating challenge:", error);
    }
  };

  const handlePublishChallenge = async (publishChallengeId) => {
    try {
      await publishChallenge({
        variables: {
          challengeId: publishChallengeId,
          name: props?.session?.me?.clientName,
        },
        refetchQueries: [
          {
            query: GET_CLIENT,
            variables: {
              name: props?.session?.me?.clientName,
            },
          },
        ],
      })
        .then(() => {
          handleClosePublish();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating challenge:", error);
    }
  };

  const handleUnpublishChallenge = async (publishChallengeId) => {
    try {
      await publishChallenge({
        variables: {
          challengeId: publishChallengeId,
          name: props?.session?.me?.clientName,
          publish: false,
        },
      })
        .then(() => {
          handleClosePublish();
          handleCloseUnpublish();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating challenge:", error);
    }
  };

  const handleDeleteChallenge = async (deleteChallengeId) => {
    try {
      await deleteChallenge({
        variables: {
          challengeId: deleteChallengeId,
          name: props?.session?.me?.clientName,
        },
      })
        .then(() => {
          handleCloseDelete();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error deleting challenge:", error);
    }
  };

  const options = [
    { value: "daily check-in", label: "Daily Energy Check-in" },
    { value: "mood", label: "Mood" },
    { value: "journal", label: "Journal" },
    { value: "gratitude journal", label: "Gratitude Journal" },
    { value: "affirmations", label: "Affirmations" },
    { value: "body", label: "Body" },
    { value: "movement", label: "Movement" },
    { value: "breathe", label: "Breathe" },
    { value: "meditation", label: "Meditation" },
    { value: "visualization", label: "Visualization" },
    { value: "community", label: "Engage with community" },
  ];

  const ageOptions = [
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "Adult", label: "Adult" },
  ];

  return (
    <Query
      query={GET_CLIENT}
      variables={{
        name: props?.session?.me?.clientName,
      }}
    >
      {({ loading, data, refetch }) => {
        if (loading) return "Loading...";
        const { getClient } = data;
        const { challenges, habits, adminUsers = [] } = getClient || {};

        const tableData = map(challenges, (challenge, key) => {
          return {
            id: key,
            ...challenge,
            challenge,
            published: challenge?.published ? "Yes" : "No",
          };
        });
        return (
          <>
            <Container fluid>
              <Row>
                <Col md="12">
                  <h4 className="title">Challenge Manager</h4>
                  {/* <p className="category">
                          A powerful react plugin handcrafted by our friends from{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            react-table
                          </a>
                          . It is a highly flexible tool, based upon the foundations of
                          progressive enhancement on which you can add advanced interaction
                          controls. Please check out their{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            full documentation.
                          </a>
                        </p> */}
                  <Card>
                    <Card.Body>
                      <ReactTable
                        data={tableData}
                        columns={[
                          {
                            header: "Title",
                            accessorKey: "title",
                          },
                          {
                            header: "Challenge Description",
                            accessorKey: "description",
                          },
                          {
                            header: "Challenge duration",
                            accessorKey: "duration",
                          },
                          {
                            header: "Challenge Commitment",
                            accessorKey: "commitment",
                          },
                          {
                            header: "Image Link",
                            accessorKey: "imageLink",
                          },
                          {
                            header: "Published",
                            accessorKey: "published",
                          },
                          {
                            header: "Actions",
                            accessorKey: "actions",
                            enableSorting: false,
                            enableColumnFilter: false,
                            cell: ({ row }) => {
                              const { challenge } = row.original;
                              return (
                                // we've added some custom button actions
                                <div className="actions-right">
                                  {/* use this button to add a edit kind of action */}
                                  <Button
                                    variant="success"
                                    size="sm"
                                    className="text-success btn-link edit"
                                    onClick={
                                      challenge?.published
                                        ? () => handleOpenUnpublish(challenge)
                                        : () => handleOpenPublish(challenge)
                                    }
                                  >
                                    <i className="fa fa-paper-plane" />
                                  </Button>{" "}
                                  <Button
                                    variant="warning"
                                    size="sm"
                                    className="text-warning btn-link edit"
                                    onClick={() => handleOpenEdit(challenge)}
                                  >
                                    <i className="fa fa-edit" />
                                  </Button>{" "}
                                  <Button
                                    variant="info"
                                    size="sm"
                                    className="text-info btn-link copy"
                                    onClick={() => handleOpenCopy(challenge)}
                                  >
                                    <i className="fa fa-copy" />
                                  </Button>{" "}
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    className="text-danger btn-link edit"
                                    onClick={() => handleOpenDelete(challenge)}
                                  >
                                    <i className="fa fa-trash" />
                                  </Button>{" "}
                                </div>
                              );
                            },
                          },
                        ]}
                        /*
                                You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                              */
                        className="-striped -highlight primary-pagination"
                      />
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs="12" style={{ marginTop: 25, textAlign: "right" }}>
                  <Button
                    onClick={() => setModal(!modal)}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Add Challenge
                  </Button>
                </Col>
              </Row>
            </Container>
            <Modal
              className="modal-primary"
              onHide={handleClose}
              show={modal}
              size="lg"
            >
              <Modal.Header className="justify-content-center">
                <label>{editChallengeId ? "Edit" : "Add"} Challenge</label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>Title</label>
                    <Form.Control
                      value={title}
                      placeholder="Title"
                      type="string"
                      onChange={(event) => setTitle(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Challenge Description</label>
                    <ReactQuill
                      value={description}
                      onChange={(value) => {
                        if (value === "<p><br></p>") setDescription("");
                        else setDescription(value);
                      }}
                      modules={modules}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Challenge Duration</label>
                    <Form.Control
                      value={duration}
                      placeholder="Challenge Duration"
                      type="number"
                      onChange={(event) =>
                        handleChangeDuration(Math.floor(event.target.value))
                      }
                    />
                  </Form.Group>
                  <Form.Check className="mb-1 pl-0">
                    <Form.Check.Label>
                      <Form.Check.Input
                        checked={timedChallenge}
                        value={timedChallenge}
                        type="checkbox"
                        onChange={(event) => {
                          setTimedChallenge(!timedChallenge);
                        }}
                      ></Form.Check.Input>
                      <span className="form-check-sign"></span>
                      Do you want to make this challenge global?
                    </Form.Check.Label>
                  </Form.Check>
                  {timedChallenge && (
                    <>
                      <Form.Group>
                        <label>Challenge Start Date</label>
                        <DatePicker
                          selected={startDate}
                          onChange={setStartDate}
                          placeholderText="Challenge Start Date"
                          customInput={
                            <Form.Control
                              style={{
                                borderColor: "black",
                                color: "black",
                                borderWidth: 1,
                                padding: 10,
                                borderRadius: 50,
                                marginBottom: 10,
                              }}
                            ></Form.Control>
                          }
                        />
                      </Form.Group>
                      <Form.Group>
                        <label>Challenge Type</label>
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          placeholder="Choose Type"
                          name="challengeType"
                          closeMenuOnSelect={true}
                          value={challengeType} // Controlled by the selectedOption state
                          onChange={(value) => setChallengeType(value)}
                          options={typeOptions}
                        />
                      </Form.Group>
                    </>
                  )}
                  <Form.Group>
                    <label>Challenge Difficulty</label>
                    <Form.Control
                      value={difficulty}
                      placeholder="Challenge Difficulty"
                      type="string"
                      onChange={(event) => setDifficulty(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Challenge Commitment</label>
                    <Form.Control
                      value={commitment}
                      placeholder="Challenge Commitment"
                      type="string"
                      onChange={(event) => setCommitment(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Image</label>
                    <Row style={{ marginLeft: 0 }}>
                      <Dropzone
                        onDrop={handleOnDrop}
                        accept={FILETYPES}
                        maxSize={MAXSIZE}
                        multiple={false}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <section style={{ padding: 0 }}>
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <Button
                                size="small"
                                variant="contained"
                                color="primary"
                              >
                                {"Upload File"}
                              </Button>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                      {imageLink && (
                        <Button
                          className="btn-link btn-icon"
                          type="button"
                          variant="success"
                          onClick={() => setImageLink("")}
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      )}
                    </Row>
                    <Form.Control
                      value={imageLink}
                      placeholder="Image Link"
                      type="string"
                      disabled
                      onChange={(event) => setImageLink(event.target.value)}
                      style={{ marginTop: 5, marginBottom: 5 }}
                    />
                    {imageLink && (
                      <img
                        key={imageLink}
                        src={imageLink}
                        height="100"
                        width="150"
                      />
                    )}
                  </Form.Group>
                  {duration > 0 && (
                    <>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Choose Day"
                        name="dayDropdown"
                        closeMenuOnSelect={true}
                        value={activeItem} // Controlled by the selectedOption state
                        onChange={(value) => setActiveItem(value)}
                        options={concat(
                          [{ value: "welcome", label: `Welcome` }],
                          map(
                            slice(scheduleItems, 0, duration),
                            (item, index) => {
                              return {
                                value: index,
                                label: `Day ${index + 1}`,
                              };
                            }
                          ),
                          [{ value: "ending", label: `Ending` }]
                        )}
                      />
                      <div
                        style={{
                          display:
                            "welcome" === activeItem?.value ? "block" : "none",
                        }}
                      >
                        <Form.Group>
                          <label>Welcome Title</label>
                          <Form.Control
                            value={welcomeItem?.title || ""}
                            placeholder="Welcome Title"
                            type="string"
                            onChange={(event) =>
                              onChangeScheduleItem(
                                event.target.value,
                                "title",
                                "welcome",
                                welcomeItem
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Welcome Description</label>
                          <ReactQuill
                            value={welcomeItem?.description || ""}
                            onChange={(value) => {
                              // Check for empty content placeholder
                              if (value === "<p><br></p>") {
                                debouncedOnChange(
                                  "",
                                  "description",
                                  "welcome",
                                  welcomeItem
                                );
                              } else {
                                debouncedOnChange(
                                  value,
                                  "description",
                                  "welcome",
                                  welcomeItem
                                );
                              }
                            }}
                            modules={modules}
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Video Link</label>
                          <Form.Control
                            value={welcomeItem?.videoLink || ""}
                            placeholder="Video Link"
                            type="string"
                            onChange={(event) =>
                              onChangeScheduleItem(
                                event.target.value,
                                "videoLink",
                                "welcome",
                                welcomeItem
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Lesson Text</label>
                          <ReactQuill
                            value={welcomeItem?.lessonText || ""}
                            onChange={(value) => {
                              if (value === "<p><br></p>")
                                debouncedOnChange(
                                  "",
                                  "lessonText",
                                  "welcome",
                                  welcomeItem
                                );
                              else
                                debouncedOnChange(
                                  value,
                                  "lessonText",
                                  "welcome",
                                  welcomeItem
                                );
                            }}
                            modules={modules}
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Activities</label>
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            placeholder="Choose Activities"
                            name="multipleSelect"
                            closeMenuOnSelect={false}
                            isMulti
                            value={(welcomeItem?.activities || []).map(
                              (activity) => {
                                const matchingOption = options.find(
                                  (option) =>
                                    option.value === activity ||
                                    option.value === activity.value
                                );
                                return (
                                  matchingOption || {
                                    value: activity,
                                    label: activity.label || activity,
                                  }
                                );
                              }
                            )}
                            onChange={(selectedOptions) => {
                              // If selectedOptions is null or undefined, default to an empty array
                              const activitiesValues = (
                                selectedOptions || []
                              ).map((option) => {
                                return typeof option === "object"
                                  ? option.value
                                  : option;
                              });

                              onChangeScheduleItem(
                                activitiesValues,
                                "activities",
                                "welcome",
                                welcomeItem
                              );
                            }}
                            options={options} // Use the options array here
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Habits</label>
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            placeholder="Choose Habits"
                            name="multipleSelect"
                            closeMenuOnSelect={false}
                            isMulti
                            value={(welcomeItem?.habits || []).map((habit) => {
                              const matchingOption = options.find(
                                (option) =>
                                  option.value === habit ||
                                  option.value === habit.value
                              );
                              return (
                                matchingOption || {
                                  value: habit,
                                  label: habit.title,
                                }
                              );
                            })}
                            onChange={(selectedOptions) => {
                              // If selectedOptions is null or undefined, default to an empty array
                              const habitValues = (selectedOptions || []).map(
                                (option) => {
                                  return typeof option === "object"
                                    ? option.value
                                    : option;
                                }
                              );

                              onChangeScheduleItem(
                                habitValues,
                                "habits",
                                "welcome",
                                welcomeItem
                              );
                            }}
                            options={map(habits, (habit) => {
                              return {
                                value: habit,
                                label: habit.title,
                              };
                            })} // Use the options array here
                          />
                        </Form.Group>
                        {timedChallenge && (
                          <>
                            <Form.Group>
                              <label>Community Post</label>
                              <Form.Control
                                value={welcomeItem?.communityPostText || ""}
                                placeholder="Community Post"
                                type="string"
                                onChange={(event) =>
                                  onChangeScheduleItem(
                                    event.target.value,
                                    "communityPostText",
                                    "welcome",
                                    welcomeItem
                                  )
                                }
                              />
                            </Form.Group>
                            <Form.Group>
                              <label>Community Post Image</label>
                              <Row style={{ marginLeft: 0 }}>
                                <Dropzone
                                  onDrop={handleOnDropSchedule("welcome")}
                                  accept={FILETYPES}
                                  maxSize={MAXSIZE}
                                  multiple={false}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <section style={{ padding: 0 }}>
                                      <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="primary"
                                        >
                                          {"Upload File"}
                                        </Button>
                                      </div>
                                    </section>
                                  )}
                                </Dropzone>
                                {welcomeItem?.communityPostImage && (
                                  <Button
                                    className="btn-link btn-icon"
                                    type="button"
                                    variant="success"
                                    onClick={() =>
                                      onChangeScheduleItem(
                                        "",
                                        "communityPostImage",
                                        "welcome",
                                        welcomeItem
                                      )
                                    }
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                )}
                              </Row>
                              <Form.Control
                                value={welcomeItem?.communityPostImage}
                                placeholder="Image Link"
                                type="string"
                                disabled
                                style={{ marginTop: 5, marginBottom: 5 }}
                              />
                              {welcomeItem?.communityPostImage && (
                                <img
                                  src={welcomeItem?.communityPostImage}
                                  height="100"
                                  width="150"
                                />
                              )}
                            </Form.Group>
                            <Form.Group>
                              <label>Admin Community Post</label>
                              <Form.Control
                                value={
                                  welcomeItem?.adminCommunityPostText || ""
                                }
                                placeholder="Community Post"
                                type="string"
                                onChange={(event) =>
                                  onChangeScheduleItem(
                                    event.target.value,
                                    "adminCommunityPostText",
                                    "welcome",
                                    welcomeItem
                                  )
                                }
                              />
                            </Form.Group>
                            <Form.Group>
                              <label>Admin Community Post Image</label>
                              <Row style={{ marginLeft: 0 }}>
                                <Dropzone
                                  onDrop={handleOnDropSchedule("welcome", true)}
                                  accept={FILETYPES}
                                  maxSize={MAXSIZE}
                                  multiple={false}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <section style={{ padding: 0 }}>
                                      <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="primary"
                                        >
                                          {"Upload File"}
                                        </Button>
                                      </div>
                                    </section>
                                  )}
                                </Dropzone>
                                {welcomeItem?.adminCommunityPostImage && (
                                  <Button
                                    className="btn-link btn-icon"
                                    type="button"
                                    variant="success"
                                    onClick={() =>
                                      onChangeScheduleItem(
                                        "",
                                        "adminCommunityPostImage",
                                        "welcome",
                                        welcomeItem
                                      )
                                    }
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                )}
                              </Row>
                              <Form.Control
                                value={welcomeItem?.adminCommunityPostImage}
                                placeholder="Image Link"
                                type="string"
                                disabled
                                style={{ marginTop: 5, marginBottom: 5 }}
                              />
                              {welcomeItem?.adminCommunityPostImage && (
                                <img
                                  src={welcomeItem?.adminCommunityPostImage}
                                  height="100"
                                  width="150"
                                />
                              )}
                            </Form.Group>
                          </>
                        )}
                      </div>
                      {map(slice(scheduleItems, 0, duration), (item, index) => {
                        const notifications = item?.notifications || [];
                        const community = item?.community || [];
                        const adminCommunity = item?.adminCommunity || [];
                        if (index === activeItem?.value)
                          return (
                            <div
                              key={index}
                              style={{
                                display:
                                  index === activeItem?.value
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <Form.Group>
                                <label>Schedule Title</label>
                                <Form.Control
                                  value={scheduleItems[index]?.title || ""}
                                  placeholder="Schedule Title"
                                  type="string"
                                  onChange={(event) =>
                                    onChangeScheduleItem(
                                      event.target.value,
                                      "title",
                                      index
                                    )
                                  }
                                />
                              </Form.Group>
                              <Form.Group>
                                <label>Schedule Description</label>
                                <ReactQuill
                                  value={
                                    scheduleItems[index]?.description || ""
                                  }
                                  onChange={(value) => {
                                    if (value === "<p><br></p>")
                                      onChangeScheduleItem(
                                        "",
                                        "description",
                                        index
                                      );
                                    else
                                      onChangeScheduleItem(
                                        value,
                                        "description",
                                        index
                                      );
                                  }}
                                  modules={modules}
                                />
                              </Form.Group>
                              <Form.Group>
                                <label>Video Link</label>
                                <Form.Control
                                  value={scheduleItems[index]?.videoLink || ""}
                                  placeholder="Video Link"
                                  type="string"
                                  onChange={(event) =>
                                    onChangeScheduleItem(
                                      event.target.value,
                                      "videoLink",
                                      index
                                    )
                                  }
                                />
                              </Form.Group>
                              <Form.Group>
                                <label>Lesson Text</label>
                                <ReactQuill
                                  value={scheduleItems[index]?.lessonText || ""}
                                  onChange={(value) => {
                                    if (value === "<p><br></p>")
                                      onChangeScheduleItem(
                                        "",
                                        "lessonText",
                                        index
                                      );
                                    else
                                      onChangeScheduleItem(
                                        value,
                                        "lessonText",
                                        index
                                      );
                                  }}
                                  modules={modules}
                                />
                              </Form.Group>
                              <Form.Group>
                                <label>Activities</label>
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  placeholder="Choose Activities"
                                  name="multipleSelect"
                                  closeMenuOnSelect={false}
                                  isMulti
                                  value={(
                                    scheduleItems[index]?.activities || []
                                  ).map((activity) => {
                                    const matchingOption = options.find(
                                      (option) =>
                                        option.value === activity ||
                                        option.value === activity.value
                                    );
                                    return (
                                      matchingOption || {
                                        value: activity,
                                        label: activity.label || activity,
                                      }
                                    );
                                  })}
                                  onChange={(selectedOptions) => {
                                    // If selectedOptions is null or undefined, default to an empty array
                                    const activitiesValues = (
                                      selectedOptions || []
                                    ).map((option) => {
                                      return typeof option === "object"
                                        ? option.value
                                        : option;
                                    });

                                    onChangeScheduleItem(
                                      activitiesValues,
                                      "activities",
                                      index
                                    );
                                  }}
                                  options={options} // Use the options array here
                                />
                              </Form.Group>
                              <Form.Group>
                                <label>Habits</label>
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  placeholder="Choose Habits"
                                  name="multipleSelect"
                                  closeMenuOnSelect={false}
                                  isMulti
                                  value={(
                                    scheduleItems[index]?.habits || []
                                  ).map((habit) => {
                                    const matchingOption = options.find(
                                      (option) =>
                                        option.value === habit ||
                                        option.value === habit.value
                                    );
                                    return (
                                      matchingOption || {
                                        value: habit,
                                        label: habit.title,
                                      }
                                    );
                                  })}
                                  onChange={(selectedOptions) => {
                                    // If selectedOptions is null or undefined, default to an empty array
                                    const habitValues = (
                                      selectedOptions || []
                                    ).map((option) => {
                                      return typeof option === "object"
                                        ? option.value
                                        : option;
                                    });

                                    onChangeScheduleItem(
                                      habitValues,
                                      "habits",
                                      index
                                    );
                                  }}
                                  options={map(habits, (habit) => {
                                    return {
                                      value: habit,
                                      label: habit.title,
                                    };
                                  })} // Use the options array here
                                />
                              </Form.Group>
                              <Form.Group>
                                <label>Notification Title</label>
                                <Form.Control
                                  value={notifications[0]?.title || ""}
                                  placeholder="Notification Title"
                                  type="string"
                                  onChange={(event) =>
                                    onChangeScheduleItem(
                                      event.target.value,
                                      "notifications.0.title",
                                      index
                                    )
                                  }
                                />
                              </Form.Group>
                              <Form.Group>
                                <label>Notification Message</label>
                                <Form.Control
                                  value={notifications[0]?.message || ""}
                                  placeholder="Notification Message"
                                  type="string"
                                  onChange={(event) =>
                                    onChangeScheduleItem(
                                      event.target.value,
                                      "notifications.0.message",
                                      index
                                    )
                                  }
                                />
                              </Form.Group>
                              <Form.Group controlId="exampleForm.SelectCustom">
                                <Form.Label>Time of Notification</Form.Label>
                                <Form.Control
                                  as="select"
                                  custom
                                  value={notifications[0]?.time || 7}
                                  onChange={(event) =>
                                    onChangeScheduleItem(
                                      Number(event.target.value),
                                      "notifications.0.time",
                                      index
                                    )
                                  }
                                >
                                  <option value={0}>Midnight</option>
                                  <option value={1}>1 AM</option>
                                  <option value={2}>2 AM</option>
                                  <option value={3}>3 AM</option>
                                  <option value={4}>4 AM</option>
                                  <option value={5}>5 AM</option>
                                  <option value={6}>6 AM</option>
                                  <option value={7}>7 AM</option>
                                  <option value={8}>8 AM</option>
                                  <option value={9}>9 AM</option>
                                  <option value={10}>10 AM</option>
                                  <option value={11}>11 AM</option>
                                  <option value={12}>Noon</option>
                                  <option value={13}>1 PM</option>
                                  <option value={14}>2 PM</option>
                                  <option value={15}>3 PM</option>
                                  <option value={16}>4 PM</option>
                                  <option value={17}>5 PM</option>
                                  <option value={18}>6 PM</option>
                                  <option value={19}>7 PM</option>
                                  <option value={20}>8 PM</option>
                                  <option value={21}>9 PM</option>
                                  <option value={22}>10 PM</option>
                                  <option value={23}>11 PM</option>
                                  {/* Add more options as needed */}
                                </Form.Control>
                              </Form.Group>
                              {timedChallenge && (
                                <>
                                  <Form.Group>
                                    <label>Community Post</label>
                                    <Form.Control
                                      value={
                                        community[0]?.communityPostText || ""
                                      }
                                      placeholder="Community Post"
                                      type="string"
                                      onChange={(event) =>
                                        onChangeScheduleItem(
                                          event.target.value,
                                          "community.0.communityPostText",
                                          index
                                        )
                                      }
                                    />
                                  </Form.Group>
                                  <Form.Group>
                                    <label>Community Post Image</label>
                                    <Row style={{ marginLeft: 0 }}>
                                      <Dropzone
                                        onDrop={handleOnDropSchedule(index)}
                                        accept={FILETYPES}
                                        maxSize={MAXSIZE}
                                        multiple={false}
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <section style={{ padding: 0 }}>
                                            <div {...getRootProps()}>
                                              <input {...getInputProps()} />
                                              <Button
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                              >
                                                {"Upload File"}
                                              </Button>
                                            </div>
                                          </section>
                                        )}
                                      </Dropzone>
                                      {community[0]?.communityPostImage && (
                                        <Button
                                          className="btn-link btn-icon"
                                          type="button"
                                          variant="success"
                                          onClick={() =>
                                            onChangeScheduleItem(
                                              "",
                                              "community.0.communityPostImage",
                                              index
                                            )
                                          }
                                        >
                                          <i className="fas fa-trash"></i>
                                        </Button>
                                      )}
                                    </Row>
                                    <Form.Control
                                      value={community[0]?.communityPostImage}
                                      placeholder="Image Link"
                                      type="string"
                                      disabled
                                      style={{ marginTop: 5, marginBottom: 5 }}
                                    />
                                    {community[0]?.communityPostImage && (
                                      <img
                                        src={community[0]?.communityPostImage}
                                        height="100"
                                        width="150"
                                      />
                                    )}
                                  </Form.Group>
                                </>
                              )}
                            </div>
                          );
                      })}
                      <div
                        style={{
                          display:
                            "ending" === activeItem?.value ? "block" : "none",
                        }}
                      >
                        <Form.Group>
                          <label>Ending Title</label>
                          <Form.Control
                            value={endingItem?.title || ""}
                            placeholder="Ending Title"
                            type="string"
                            onChange={(event) =>
                              onChangeScheduleItem(
                                event.target.value,
                                "title",
                                "ending"
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Ending Description</label>
                          <ReactQuill
                            value={endingItem?.description || ""}
                            onChange={(value) => {
                              if (value === "<p><br></p>")
                                onChangeScheduleItem(
                                  "",
                                  "description",
                                  "ending"
                                );
                              else
                                onChangeScheduleItem(
                                  value,
                                  "description",
                                  "ending"
                                );
                            }}
                            modules={modules}
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Video Link</label>
                          <Form.Control
                            value={endingItem?.videoLink || ""}
                            placeholder="Video Link"
                            type="string"
                            onChange={(event) =>
                              onChangeScheduleItem(
                                event.target.value,
                                "videoLink",
                                "ending"
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Lesson Text</label>
                          <ReactQuill
                            value={endingItem?.lessonText || ""}
                            onChange={(value) => {
                              if (value === "<p><br></p>")
                                onChangeScheduleItem(
                                  "",
                                  "lessonText",
                                  "ending"
                                );
                              else
                                onChangeScheduleItem(
                                  value,
                                  "lessonText",
                                  "ending"
                                );
                            }}
                            modules={modules}
                          />
                        </Form.Group>
                      </div>
                    </>
                  )}
                </Form>
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClose}
                  variant="link"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={
                    editChallengeId
                      ? () => handleEditChallenge(editChallengeId)
                      : handleAddChallenge
                  }
                  variant="outlined"
                  color="primary"
                  disabled={
                    !title ||
                    !description ||
                    !duration ||
                    !difficulty ||
                    !commitment ||
                    !imageLink ||
                    (timedChallenge && !startDate)
                  }
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleClosePublish}
              show={publishModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Publish Challenge</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to publish this Challenge?
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClosePublish}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={() => handlePublishChallenge(publishChallengeId)}
                  // variant="danger"
                  color="primary"
                >
                  Publish Challenge
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseUnpublish}
              show={unpublishModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Unpublish Challenge</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to remove this Challenge from the avalible
                challenges
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseUnpublish}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={() => handleUnpublishChallenge(publishChallengeId)}
                  // variant="danger"
                  color="primary"
                >
                  Unpublish Challenge
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseCopy}
              show={copyModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Copy Challenge</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to copy this Challenge?
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseCopy}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={() => handleCopyChallenge(copyChallenge)}
                  variant="info"
                  color="primary"
                >
                  Copy Challenge
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseDelete}
              show={deleteModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Delete Challenge</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this Challenge? This action
                cannot be undone
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseDelete}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={() => handleDeleteChallenge(deleteChallengeId)}
                  variant="danger"
                  color="primary"
                >
                  Delete Challenge
                </Button>
              </div>
            </Modal>
          </>
        );
      }}
    </Query>
  );
}

export default withSession(ChallengeManager);
